import React from 'react';

import ShPageHeader from '../../web-sh/src/components/common/PageHeader';
import pageHeaderComponents from '../page-header';

function PageHeader(props) {
  const {
    WelcomeBanner
  } = pageHeaderComponents;

  return (
    <>
      <WelcomeBanner />
      <ShPageHeader { ...props }/>
    </>
  );
}

export default PageHeader;
